import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {StatusMessage} from '../../../graphql/common.datatypes';
import {CreatePaymentInput} from '../PaymentEditModal/createPayment.api';
import {Payment} from "../../../graphql/payments.datatypes";

interface CreateFirstPaymentData {
    createFirstPayment: Payment
}

export const CREATE_PAYMENT_MUTATION = gql`
    mutation createFirstPayment($data: CreatePaymentInput!) {
        createFirstPayment(data: $data) {
            message
            status
            id
        }
    }
`;

export const createFirstPayment = () => useMutation<CreateFirstPaymentData, CreatePaymentInput >(
    CREATE_PAYMENT_MUTATION,
    {
        //update: updateCacheByType('Payment'),
    }
);

export default createFirstPayment;
